export const activityTypes = {
  APPLICATION: 'application',
  FERTILITY_FALL: 'fertility-fall',
  FERTILITY_PRE_PLANT: 'fertility-pre-plant',
  FERTILITY_IN_SEASON: 'fertility-in-season',
  FERTILITY_LATE_SEASON: 'fertility-late-season',
  FERTILITY_OTHER: 'fertility-other',
  PLANTING: 'planting'
} as const;

export const protectionApplicationTypes = {
  'APPLICATION_FUNGICIDE': 'application-fungicide',
  'APPLICATION_HERBICIDE': 'application-herbicide',
  'APPLICATION_INSECTICIDE': 'application-insecticide',
  'APPLICATION_GROWTHREGULATOR': 'application-growthregulator',
  'APPLICATION_MIX': 'application-mix'
};

export const prodChemicalIds = {
  fungicide: 'ca2a1a3e-9311-4389-b231-618a0f6da33d',
  herbicide: '8b07ad79-09f1-4bdc-9508-fd9ebb0476cf',
  insecticide: '71469db3-2620-40de-8a08-6193160bfc61',
  growthregulator: '248e8cea-baeb-4920-a726-012f3c56d189'
};

export const experimentChemicalIds = {
  fungicide: prodChemicalIds.fungicide
};

export const qaChemicalIds = {
  fungicide: 'dba37198-438a-43a8-98e8-2fac5cf908be',
  herbicide: '5dfaf722-2ee2-4ba2-a1b8-78605cebf53f',
  insecticide: '3b3d6c7b-8c11-4120-af8a-0081eb58879a',
  growthregulator: '93f7c68c-68c4-470c-81bd-427ece42b342'
};

// TODO: move these dates to service -- groot or other?

export const activityCategoryDefaultDates = {
  [activityTypes.FERTILITY_FALL]: '11-01',
  [activityTypes.FERTILITY_PRE_PLANT]: '04-15',
  [activityTypes.FERTILITY_IN_SEASON]: '06-15',
  [activityTypes.FERTILITY_LATE_SEASON]: '07-15',
  [activityTypes.FERTILITY_OTHER]: '04-15',
  [activityTypes.PLANTING]: '04-15'
};

export const activityCategories = {
  result: {
    US: [
      {
        fertility: {
          '5cfec4cb-3570-45fd-a6fc-d942b6b1ca60': { code: 'fall', 'category-name': 'Fall' },
          '951a418b-2e82-4292-9bec-60cc6266c8d3': { code: 'pre-plant', 'category-name': 'Pre-Plant' },
          '1f57a4f6-6104-47f7-94aa-02ea32995039': { code: 'in-season', 'category-name': 'In-Season' },
          'f2870abc-18c2-4c47-9509-af8e8c6a21ee': { code: 'late-season', 'category-name': 'Late-Season' },
          '30fb10fc-6de5-49c9-9e32-6c2d050a80a5': { code: 'other', 'category-name': 'Other' }
        }
      }
    ]
  }
};
